import { lazy, Suspense } from "react";
import { Hero } from "@/components/Hero";
import { SEOHead } from "@/components/SEOHead";
import { WhatsAppButton } from "@/components/WhatsAppButton";

// Lazy load components below the fold
const AudioPlayer = lazy(() => import("@/components/AudioPlayer").then(m => ({ default: m.AudioPlayer })));
const About = lazy(() => import("@/components/About").then(m => ({ default: m.About })));
const Portfolio = lazy(() => import("@/components/Portfolio").then(m => ({ default: m.Portfolio })));
const AboutEllen = lazy(() => import("@/components/AboutEllen").then(m => ({ default: m.AboutEllen })));
const URAGenerator = lazy(() => import("@/components/URAGenerator").then(m => ({ default: m.URAGenerator })));
const FAQ = lazy(() => import("@/components/FAQ").then(m => ({ default: m.FAQ })));
const Contact = lazy(() => import("@/components/Contact").then(m => ({ default: m.Contact })));
const Footer = lazy(() => import("@/components/Footer").then(m => ({ default: m.Footer })));

const Index = () => {
  return (
    <>
      <SEOHead />
      <main className="min-h-screen">
        <Hero />
        <Suspense fallback={<div className="min-h-screen" />}>
          <AudioPlayer />
          <About />
          <Portfolio />
          <AboutEllen />
          <URAGenerator />
          <FAQ />
          <Contact />
          <Footer />
        </Suspense>
      </main>
      <WhatsAppButton />
    </>
  );
};

export default Index;
